export default {"src":"/_next/static/media/dreamcase_logo_white.4fb398bb.svg","height":97,"width":568};